var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 352.392,
    height: 209.224,
    viewBox: "0 0 352.392 209.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42127",
    "data-name": "Path 42127",
    d: "M211.542,46.456a235.046,235.046,0,0,0-25.832,3.082c-9.831,1.887-16.155,2.383-30.335,2.38a336.4,336.4,0,0,1-40.4-2.439C103.5,47.9,88.764,48.59,79.063,51.17a15.933,15.933,0,0,0-9.2,7.083c-1.184,2.1-1.365,3.411-1.365,9.858a46.637,46.637,0,0,0,1.937,14.864l1.937,7.432,2.515,20.526c-.037,18.7-2.8,26.567-3.642,30.436-2.388,11.036-2,21.7,1.5,41.387,3.349,18.845,3.2,24.31-1.033,38.49-2.9,9.726-3.31,13.236-2.01,17.408,3.724,11.949,12.836,16.956,28.241,15.517,3.041-.284,13.062-2.105,22.27-4.047,16.067-3.388,17.067-3.533,24.814-3.582,7.108-.046,8.766.124,13.877,1.422,8.143,2.068,16.38,3.064,28.745,3.478,15.237.51,35.765-.16,57.6-1.879,17.8-1.4,20.8-1.49,50.251-1.481,34.861.011,44.063.513,65.491,3.572a126.8,126.8,0,0,0,22.659,1.682c8.409.011,11.961-.2,15.176-.9,9.346-2.046,13.611-2,16.876-8.542s-3.481-14.775-3.178-25.432c.458-16.116,6.939-20.3,7.314-33.862s-.481-16.843-5.179-30.74c-2.862-8.464-2.842-23.4.072-53.892,1.957-20.481,2.333-36.493.971-41.407-1.178-4.251-3.483-7.877-5.912-9.3-2.349-1.375-8.6-2.141-14.8-1.812-2.331.123-9.179.477-15.217.785s-23.161,1.384-38.052,2.39-30.2,1.83-34.032,1.83a185.938,185.938,0,0,1-29.358-2.877c-16.1-2.7-27.6-3.515-48.059-3.39-8.347.051-16.774.173-18.728.272",
    transform: "translate(-68 -45.677)",
    fill: "#f8f8ff",
    stroke: "#ededfa",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/Description.9af3d622f808be8d1ef71c5cc6cdf54c.svg";
export { ForwardRef as ReactComponent };